import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class EventService {
  public eventHandler: Subject<any> = new Subject<any>();

  broadcast(eventName: string, data?: any) {
    this.eventHandler.next({ eventName, data });
  }

  on(eventName: string, callback: any): Subscription {
    return this.eventHandler
      .pipe(filter((event) => event.eventName === eventName))
      .subscribe(callback);
  }

  // Server Events
  onDownloadCompleteReceived(callback: (uniqueID: string) => void): Subscription {
    return this.on(HRIMServerEvents.downloadComplete, (event: any) => {
      callback(event.data.uniqueID);
    });
  }

  onSendProgressCountReceived(callback: (current: number, total: number, uniqueID: string) => void): Subscription {
    return this.on(HRIMServerEvents.sendProgressCount, (event: any) => {
      callback(event.data.current, event.data.total, event.data.uniqueID);
    });
  }

  onSendProgressFileName(callback: (fileName: string, uniqueID: string) => void): Subscription {
    return this.on(HRIMServerEvents.sendProgressFileName, (event: any) => {
      callback(event.data.fileName, event.data.uniqueID);
    });
  }

  onSendLogoutSignalReceived(callback: () => void): Subscription {
    return this.on(HRIMServerEvents.sendLogoutSignal, () => {
      callback();
    });
  }

  onSendApprovalCountReceived(callback: (approval: string, count: number) => void): Subscription {
    return this.on(HRIMServerEvents.sendApprovalCount, (event: any) => {
      callback(event.data.approval, event.data.count);
    })
  }

  onSendPortalSettingsUpdateReceived(callback: () => void): Subscription {
    return this.on(HRIMServerEvents.sendPortalSettingsUpdate, () => {
      callback();
    });
  }

  // Browser Events
  openSpinner(msg: string, showProgress: boolean, uniqueID: string) {
    this.broadcast(HRIMBrowserEvents.openSpinner, { msg, showProgress, uniqueID });
  }

  onOpenSpinnerReceived(callback: (msg: string, showProgress: boolean, uniqueID: string) => void): Subscription {
    return this.on(HRIMBrowserEvents.openSpinner, (event: any) => {
      callback(event.data.msg, event.data.showProgress, event.data.uniqueID);
    })
  }

  updateSpinnerMsg(msg: string, uniqueID: string) {
    this.broadcast(HRIMBrowserEvents.updateSpinnerMsg, { msg, uniqueID });
  }

  onUpdateSpinnerMsg(callback: (msg: string, uniqueID: string) => void): Subscription {
    return this.on(HRIMBrowserEvents.updateSpinnerMsg, (event: any) => {
      callback(event.data.msg, event.data.uniqueID);
    });
  }

  closeSpinner(uniqueID: string) {
    this.broadcast(HRIMBrowserEvents.closeSpinner, { uniqueID });
  }

  onCloseSpinnerReceived(callback: (uniqueID: string) => void): Subscription {
    return this.on(HRIMBrowserEvents.closeSpinner, (event: any) => {
      callback(event.data.uniqueID);
    });
  }

  updateProgressSpinnerCount (current: number, total: number, uniqueID: string) {
    this.broadcast(HRIMServerEvents.sendProgressCount, { current, total, uniqueID });
  }
}

export const HRIMServerEvents = {
  downloadComplete: "Server_DownloadComplete",
  sendProgressFileName: "Server_SendProgressFileName",
  sendProgressCount: "Server_SendProgressCount",
  sendLogoutSignal: "Server_SendLogoutSignal",
  sendApprovalCount: "Server_SendApprovalCount",
  sendPortalSettingsUpdate: "Server_SendPortalSettingsUpdate"
} as const

export const HRIMBrowserEvents = {
  modulesChanged: "Local_modulesChanged",
  approvedTimecardsChanged: "Local_approvedTimecardsChanged",
  approvedBenefitMinus: "Local_approvedBenefitMinus",
  approvedDependentChanged: "Local_approvedDependentChanged",
  approvedTimeoffChanged: "Local_approvedTimeoffChanged",
  productionApprovalChanged: "Local_productionApprovalChanged",
  openSpinner: "Local_openSpinner",
  closeSpinner: "Local_closeSpinner",
  updateSpinnerMsg: "Local_updateSpinnerMsg"
} as const

export const GlobalSpinnerMessages = {
  loading: "Loading...",
  pleaseWait: "Please wait...",
  processing: "Please wait while the page is processing...",
  retrieved: "Please wait while your document is retrieved...",
} as const